import * as React from 'react';
import C from 'classnames';
export const CardHeaderTab = props => {
    return (React.createElement("li", { className: C('nav-item', props.className) },
        React.createElement("a", { className: C('nav-link', props.selected && 'active'), onClick: () => props.onSelect(props.label) }, props.children)));
};
//# sourceMappingURL=CardHeaderTab.js.map